import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import CloseDialogButton from "../../../components/CloseDialogButton";

const ResendInviteDialog = ({
  open,
  onClose,
  onConfirm,
  user,
  brands,
  restaurants,
  loading,
}) => {
  const [brandId, setBrandId] = useState("");
  const [restaurantId, setRestaurantId] = useState("");

  useEffect(() => {
    if (open && user) {
      setBrandId(user.is_super ? "" : user.brand_id || "");
      setRestaurantId("");
    }
  }, [open, user]);

  const restaurantsForBrand = useMemo(() => {
    const scope = user?.is_super ? brandId : user?.brand_id;
    if (!scope) return [];
    return restaurants.filter((r) => r.brand_id === scope);
  }, [restaurants, user, brandId]);

  const brandName = (id) => brands.find((b) => b.id === id)?.name || "—";

  if (!user) return null;

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ pr: 7 }}>
        Resend invite to {user.username}
        <CloseDialogButton onClose={onClose} loading={loading} />
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <Typography variant="body2" color="text.secondary">
            The invite link drops them onto a specific branch on first login.
            Pick which one.
          </Typography>

          {user.is_super ? (
            <FormControl fullWidth required>
              <InputLabel>Brand</InputLabel>
              <Select
                label="Brand"
                value={brandId || ""}
                onChange={(e) => {
                  setBrandId(e.target.value);
                  setRestaurantId("");
                }}
              >
                {brands.map((b) => (
                  <MenuItem key={b.id} value={b.id}>
                    {b.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          ) : (
            <Typography variant="body2">
              Brand: <strong>{brandName(user.brand_id)}</strong>
            </Typography>
          )}

          <FormControl fullWidth required disabled={user.is_super && !brandId}>
            <InputLabel>Branch (initial restaurant)</InputLabel>
            <Select
              label="Branch (initial restaurant)"
              value={restaurantId || ""}
              onChange={(e) => setRestaurantId(e.target.value)}
            >
              {restaurantsForBrand.map((r) => (
                <MenuItem key={r.id} value={r.id}>
                  {r.restaurant_name}
                </MenuItem>
              ))}
              {restaurantsForBrand.length === 0 && (
                <MenuItem disabled value="">
                  <em>No restaurants in this brand</em>
                </MenuItem>
              )}
            </Select>
          </FormControl>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => onConfirm(restaurantId)}
          disabled={loading || !restaurantId}
        >
          {loading ? "Sending…" : "Send invite"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResendInviteDialog;
